
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.888 12.268l-1.356-2.153.804-2.416a.733.733 0 00-.326-.865l-2.193-1.273-.404-2.516a.73.73 0 00-.688-.613l-2.53-.1-1.518-2.04a.72.72 0 00-.891-.22L11.5 1.165 9.214.07a.724.724 0 00-.892.222l-1.518 2.04-2.53.1a.727.727 0 00-.687.612L3.183 5.56.99 6.833a.733.733 0 00-.327.865l.804 2.416-1.355 2.153a.735.735 0 00.112.919L2.05 14.95l-.206 2.539a.731.731 0 00.522.762l2.432.705.99 2.346a.722.722 0 00.812.43l2.481-.512 1.958 1.615a.728.728 0 00.46.165.73.73 0 00.46-.165l1.958-1.615 2.48.512a.723.723 0 00.814-.43l.99-2.346 2.431-.705a.73.73 0 00.522-.762l-.206-2.54 1.827-1.763a.735.735 0 00.112-.918zm-6.143-3.514l-5.079 7.66c-.192.286-.49.477-.784.477-.295 0-.624-.166-.834-.378l-3.729-3.814a.679.679 0 010-.944l.92-.943a.645.645 0 01.92 0l2.427 2.482 4.002-6.036a.643.643 0 01.905-.177l1.079.747a.678.678 0 01.173.926z"}})])
          )
        }
      }
    